const translation = {
  toVerifiedTip: {
    front: 'Você agora está elegível para o status de Educação Verificada. Por favor, insira suas informações educacionais abaixo para concluir o processo e receber um',
    coupon: 'cupom exclusivo de 100%',
    end: 'para o Plano Profissional Dify.',
  },
  form: {
    schoolName: {
      placeholder: 'Digite o nome oficial e não abreviado da sua escola',
      title: 'O nome da sua escola',
    },
    schoolRole: {
      option: {
        teacher: 'Professor',
        student: 'Estudante',
        administrator: 'Administrador Escolar',
      },
      title: 'Seu Papel na Escola',
    },
    terms: {
      desc: {
        and: 'e',
        privacyPolicy: 'Política de Privacidade',
        front: 'Suas informações e o uso do status de Educação Verificada estão sujeitos ao nosso',
        termsOfService: 'Termos de Serviço',
        end: 'Ao enviar:',
      },
      option: {
        inSchool: 'Eu confirmo que estou matriculado ou empregado na instituição mencionada. A Dify pode solicitar comprovação de matrícula/emprego. Se eu representar indevidamente minha elegibilidade, concordo em pagar quaisquer taxas inicialmente isentas com base no meu status educacional.',
        age: 'Eu confirmo que tenho pelo menos 18 anos',
      },
      title: 'Termos e Acordos',
    },
  },
  learn: 'Aprenda como fazer a verificação da sua educação',
  toVerified: 'Verifique a Educação',
  currentSigned: 'ATUALMENTE CONECTADO COMO',
  submit: 'Enviar',
  emailLabel: 'Seu e-mail atual',
  successContent: 'Emitimos um cupom de desconto de 100% para o plano Dify Professional na sua conta. O cupom é válido por um ano, por favor, utilize-o dentro do período de validade.',
  rejectTitle: 'A sua verificação educacional Dify foi rejeitada.',
  rejectContent: 'Infelizmente, você não é elegível para o status de Educação Verificada e, portanto, não pode receber o cupom exclusivo de 100% para o Plano Profissional Dify se usar este endereço de e-mail.',
  successTitle: 'Você Tem a Educação Dify Verificada',
  submitError: 'A submissão do formulário falhou. Por favor, tente novamente mais tarde.',
}

export default translation
